import { createCrudService } from './createCrudService';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface Module {
  id: string;
  slug: string;
  name: string;
  description: string | null;
  version: string | null;
  config: Record<string, unknown> | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateModulePayload {
  slug: string;
  name: string;
  description?: string | null;
  version?: string | null;
  config?: Record<string, unknown> | null;
  is_active?: boolean;
}

export interface UpdateModulePayload {
  slug?: string;
  name?: string;
  description?: string | null;
  version?: string | null;
  config?: Record<string, unknown> | null;
  is_active?: boolean;
}

// ---------------------------------------------------------------------------
// Service
// ---------------------------------------------------------------------------

export const modulesService = createCrudService<
  Module,
  CreateModulePayload,
  UpdateModulePayload
>('/admin/modules');
